// extracted by mini-css-extract-plugin
export default {"postTag":"Post_postTag__3B26u","wrapper":"Post_wrapper__zsmeT"};